export default "__VITE_ASSET__dgTU0a2v__"